import { Coord } from "../../types/Interface";

const getCleanCoord = (coord: Coord): Coord => ({ x: Math.floor(coord.x), y: Math.floor(coord.y) })
export default getCleanCoord;